// extracted by mini-css-extract-plugin
export default {"suggestedQueryChips":"SuggestedQueryChips_suggestedQueryChips__L6tZL"};